import React from 'react'
import {Stack, Typography} from '@mui/material'
import SessionGrid from './SessionGrid'

export default function SessionsRoute() {
  return <Stack id="sessions" spacing={3} sx={{width: '100%', maxWidth: 900, mx: 'auto'}}>
    <div><Typography variant="h3" component="h1">Sessions</Typography>
      <Typography color="text.secondary" sx={{mt: 1}}>Manage your tournament session.</Typography></div>
    <SessionGrid/>
  </Stack>
}
